export const reducerFn = (state, payload) => {
    const { type, content } = payload;

    switch (type) {
        case 'add_goals_pt':
            if (!state.goalsPt.some(item => item.key === content.key)) {
                return {
                    ...state,
                    goalsPt: [...state.goalsPt, content]
                };
            }
            return state;

        case 'add_goals_en':
            if (!state.goalsEn.some(item => item.key === content.key)) {
                return {
                    ...state,
                    goalsEn: [...state.goalsEn, content]
                };
            }
            return state;
        default:
            return state;
    }
};





